import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './projects.css';

const slugify = (str = '') => str.toString().toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

const ProjectFrame = ({ projectInfo, eager = false }) => {
    const [imgLoaded, setImgLoaded] = useState(false);
    const [imgErrored, setImgErrored] = useState(false);
    const navigate = useNavigate();
    const containerRef = useRef(null);

    const slug = slugify(projectInfo.projectName || 'project');

    const openInspector = (e) => {
        if (!projectInfo) return;
        // Use the centre of the clicked tile as the zoom origin — feels like
        // we're diving INTO that specific image rather than starting from the
        // raw cursor position. Falls back to the click point if rect missing.
        let x = e.clientX || window.innerWidth / 2;
        let y = e.clientY || window.innerHeight / 2;
        const rect = containerRef.current && containerRef.current.getBoundingClientRect();
        if (rect) {
            x = rect.left + rect.width / 2;
            y = rect.top + rect.height / 2;
        }
        document.documentElement.style.setProperty('--zoom-origin', `${x}px ${y}px`);
        window.dispatchEvent(new CustomEvent('blossom-zoom', {
            detail: { phase: 'in', x, y }
        }));
        navigate(`/projects/${slug}`);
    };

    return (
        <div
            ref={containerRef}
            className="container"
            onClick={openInspector}
            aria-label={projectInfo.projectName ? `Project: ${projectInfo.projectName}` : 'Project frame'}
            style={{ position: 'relative', height: 'clamp(20rem, 60vw, 30rem)', overflow: 'hidden' }}
        >
            <div className="container-img-wrap">
                <img
                    className={"container-img" + (imgLoaded ? ' is-loaded' : '')}
                    src={projectInfo.image}
                    alt={projectInfo.projectName || 'Project cover'}
                    loading="eager"
                    decoding="async"
                    fetchpriority={eager ? 'high' : 'auto'}
                    onLoad={() => setImgLoaded(true)}
                    onError={() => setImgErrored(true)}
                />
                {imgErrored && (
                    <div className="container-img-fallback">Image unavailable</div>
                )}
            </div>
            <div className="overlay" role="presentation">
                <div className="overlay-content">
                    <h1 className="project-title">{projectInfo.projectName || 'Untitled Project'}</h1>
                    {projectInfo.ShortD && (
                        <p className="project-shortd">{projectInfo.ShortD}</p>
                    )}
                    {projectInfo.date && (
                        <p className="project-year">
                            {new Date(projectInfo.date).getFullYear()}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProjectFrame;
